<template>
  <v-card width="400px" class="mx-auto" elevation ="0">
    <v-stepper v-model="stepNumber" vertical >
      <v-stepper-step :complete="stepNumber > 1" step="1">
        <span v-if="validated.type">Type : {{validated.type}}</span>
        <span v-else>Type</span>
      </v-stepper-step>

      <v-stepper-content step="1">
        <v-card elevation="0" class="mt-1">
          <v-form ref="stepWorkspaceType" v-model="validForm.type" lazy-validation>
            <v-select
              v-model="formInput.type"
              :items="formTypes"              
              label="Workspace Type"
              :rules="[rules.required]"
              outlined
            ></v-select>
            <v-btn @click="validateStepWorkspaceType()" color="primary">Next</v-btn>
          </v-form>
        </v-card>
      </v-stepper-content>

      <v-stepper-step :complete="stepNumber > 2" step="2">
        <span v-if="validated.name">Name : {{validated.name}}</span>
        <span v-else>Name</span>
      </v-stepper-step>

      <v-stepper-content step="2">
        <v-card elevation="0" class="mt-1">
          <v-form ref="stepWorkspaceName" v-model="validForm.name" lazy-validation>
            <v-text-field
              autocomplete="off"
              v-model="formInput.name"
              label="Workspace Name [ex: 'Personal books']"
              :rules="[rules.required]"
              outlined
            ></v-text-field>
            <v-btn @click="validateStepWorkspaceName()" color="primary">Next</v-btn>
          </v-form>
        </v-card>
      </v-stepper-content>

      <v-stepper-step :complete="stepNumber > 3" step="3">
        <span v-if="validated.currency">Currency : {{validated.currency}}</span>
        <span v-else>Currency</span>
      </v-stepper-step>

      <v-stepper-content step="3">
        <v-card elevation="0">
          <v-form ref="stepWorkspaceCurrency" v-model="validForm.currency" lazy-validation>
            <v-text-field
              autocomplete="off"
              class="mt-1"
              v-model="formInput.currency"
              v-on="onCurrency()"
              label="Currency (3 characters) [ex: 'EUR', 'USD']"
              maxlength="3"
              :rules="[rules.required]"
              outlined
            ></v-text-field>
            <v-btn color="primary" @click="validateStepWorkspaceCurrency()">Next</v-btn>
          </v-form>
        </v-card>
      </v-stepper-content>

      <v-stepper-step :complete="stepNumber > 4" step="4">
        <span v-if="validated.template">Starter template : {{validated.template.name}}</span>
        <span v-else>Starter template</span>
      </v-stepper-step>

      <v-stepper-content step="4">
        <v-card elevation="0">
          <v-form ref="stepWorkspaceTemplate" v-model="validForm.template" lazy-validation>
            <v-select
              class="mt-1"
              v-model="formInput.template"
              :items="templates"
              item-text="name"
              label="Template"
              :rules="[rules.required]"
              return-object
              outlined
            >
            </v-select>
            <v-btn color="primary" @click="validateStepWorkspaceTemplate()">Create workspace</v-btn>
          </v-form>
        </v-card>
      </v-stepper-content>
    </v-stepper>
    <v-dialog v-model="progress" persistent max-width="300">
      <v-card>
        <v-card-title class="headline"> </v-card-title>
        <v-card-text>
          <p>
            <v-progress-circular
              indeterminate
              color="primary"
              class="mr-2"
            ></v-progress-circular>
            Workspace creation in progress
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card-actions >
      <v-btn text @click="onCancel()">
        <v-icon>{{icons.mdiArrowLeft}}</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mdiArrowLeft } from "@mdi/js";


export default {
  async created() {
      this.initialState();
      await this.$store.dispatch("getTemplateList");
  },
  data: () => ({
    icons: {mdiArrowLeft},
    validForm : {},
    progress: false,
    formTypes:["Personal", "Joint", "Business"],
    validated: {},
    formInput: {},
    stepNumber: 1,
    rules: {
      required: (value) => !!value || "Required",
    },
  }),
  computed: {
    templates() {
      return this.$store.state.templateList;
    }
  },
  methods: {
    initialState() {
        this.validForm = {type:true, name:true, currency:true, template:true};
        this.formInput = this.initProp(),
        this.validated = this.initProp(),
        this.progress = false,
        this.stepNumber = 1;
    },
    initProp() {
      return {type: "", name: "", currency: "", template:undefined};
    },
    validateStepWorkspaceType() {
      this.validForm.type = this.$refs.stepWorkspaceType.validate();
      if (this.validForm.type) {
        this.stepNumber = 2;
        this.validated.type = this.formInput.type;
      }
    },
    validateStepWorkspaceName() {
      this.validForm.name = this.$refs.stepWorkspaceName.validate();
      if (this.validForm.name) {
        this.stepNumber = 3;
        this.validated.name = this.formInput.name;
      }
    },
    validateStepWorkspaceCurrency() {
      this.validForm.currency = this.$refs.stepWorkspaceCurrency.validate();
      if (this.validForm.currency) {
        this.stepNumber = 4;
        this.validated.currency = this.formInput.currency;
      }
    },
    validateStepWorkspaceTemplate() {
      this.validForm.template = this.$refs.stepWorkspaceTemplate.validate();
      if (this.validForm.template) {
        this.stepNumber = 5;
        this.progress = true;
        this.validated.template = this.formInput.template;
      }
      this.$emit("onCreate", this.validated);
    },
    onCurrency() {
      this.formInput.currency = this.formInput.currency.toUpperCase();
    },
    onCancel() {
      this.$emit("onCancel");
      this.initialState();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>